module.exports = __webpack_public_path__ + "img/Hot.48bfa589.svg";